import { Routes } from '@angular/router';
import { NoConnectivityComponent } from './core/components/no-connectivity/no-connectivity.component';
import { pagesRoutes } from './pages/pages-routes';
import { AuthComponent } from '@/app/auth/auth.component';
import { AuthService } from './auth/services/auth.service';
import { LoginComponent } from './auth/login/login.component';

export const routes: Routes = [
    { path: '', component: AuthComponent },
    {
        path: 'auth',
        providers: [AuthService],
        children: [
          { path: 'login', component: LoginComponent },
        ],
      },
    {
        path: 'no-connection',
        component: NoConnectivityComponent,
    },
    pagesRoutes,
    {
        path: '**',
        redirectTo: '/',
    },
];
